import * as $ from 'jquery';
import 'bootstrap';
import axios from "axios";

export default (function () {
 let $notificationLink = $('a.notification-link');
 let $notificationsModal = $('div#notifications');
 let $loader = $('<div class="loader"></div>');

 if (0 < $notificationLink.length) {

  $notificationLink.on('click', function() {
   if ($(this).hasClass('assigned') || $(this).hasClass('incoming')) {
    showNotifications()
   }
  })

  function showIncomingLink() {
   $notificationLink.removeClass('assigned');
   $notificationLink.addClass('incoming');
  }

  function showAssignedLink() {
   $notificationLink.removeClass('incoming')
   $notificationLink.addClass('assigned')
  }

  function showEmptyLink() {
   $notificationLink.removeClass('incoming');
   $notificationLink.removeClass('assigned');
  }

  function setCurrentStatus() {
   let $notifications = $notificationsModal.find('table');

   if (0 === $notifications.find('tr').length) {
    $notificationsModal.modal('hide');
    showEmptyLink();
    return;
   }

   if (0 < $notifications.find('tr[data-type=applicant_assigned]').length) {
    showAssignedLink();
    return;
   }

   if (0 < $notifications.find('tr[data-type=incoming_applicant]').length) {
    showIncomingLink();
   }
  }

  function showNotifications() {
   $notificationsModal.find('.modal-body').append($loader);

   axios.get("/notifications").then(function (response) {
    $notificationsModal.find('.loader').addClass('d-none');
    buildNotificationTable(response);
   })
  }

  function dismiss($dismiss) {
   axios.get("/notifications/" + $dismiss.data('nid') + "/dismiss").then(function () {
    $dismiss.parent().parent().remove();
    setCurrentStatus();
   })
  }

  function buildNotificationTable(response) {
   let notifications = response.data;
   let total = notifications.data.length;
   let $notificationTable = $('<div/>', {class: "table-wrapper"})
     .append(
       $('<div/>', {class: "notifications-total mb-1"})
         .text('Total:' + total)
         .append(
           $('<span/>', {class: "float-right pr-4"})
             .append(
               $('<a/>', {class: "d-all", href: "#"})
                 .text('dismiss all')
             )
         )
     )
     .append($('<table/>', {class: "table table-sm"}));

   $('.modal-header').append($(''));

   $(notifications.data).each(function (key, notification) {

    let title = notification.notification_type;
    if (notificationTitles[notification.notification_type]) {
     title = notificationTitles[notification.notification_type];
    }

    let $row = $('<tr/>').data('type', notification.notification_type)
      .append(
        $('<td\>')
          .append(
            $('<a\>', {'href': '/wizard/' + parseInt(notification.aid)})
              .text(notification.aid)
        )
      )
      .append($('<td\>').text(title))
      .append($('<td\>').text(notification.created_at))
      .append(
        $('<td\>')
          .append(
            $('<a\>', {'href': '#'}).data('nid', notification.id).text('dismiss')
          )
      )

    $row.find('a').on('click', function () {
     dismiss($(this));
    })

    $notificationTable.find('table').append($row);
   });

   $notificationTable.find('a.d-all').click(function() {
    let toDismiss = [];
    $notificationTable.find('a').each(function() {
     if ($(this).data('nid')) {
      toDismiss.push($(this).data('nid'));
     }
    })
    axios.post("/notifications/dismissAll", {'nids': toDismiss}).then(function() {
     $notificationsModal.modal('hide');
     showEmptyLink();
    });
   });

   $notificationsModal.find('.modal-body').append($notificationTable);
   $notificationsModal.modal().show();
  }

  $notificationsModal.on('hidden.bs.modal', function () {
   $notificationsModal.find('.modal-body').find('.table-wrapper').remove();
  })

  async function pollStatus(ms) {
   return new Promise(() => {
    setInterval(async () => {
     await getUserNotificationsStatus();
    }, ms);
   });
  }

  async function getUserNotificationsStatus() {
   try {
    await axios.get('/notifications/status').then(function (response) {
     if ('incoming' === response.data.status) {
      showIncomingLink();
     } else if ('assigned' === response.data.status) {
      showAssignedLink();
     } else {
      showEmptyLink();
     }
    });
   } catch (errorData) {
    if (errorData) {
     console.log(errorData)
    }
   }
  }

  getUserNotificationsStatus();
  pollStatus(interval);
 }



}());